module.exports = __webpack_public_path__ + "img/viewpoint2.c8345506.png";